module.exports = __webpack_public_path__ + "static/media/shopping-cart-solid.8bf1af37.svg";